/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Class of data exported by this route.
 */
export const DataExportRouteDataSource = {
  ProductTelemetry: "product_telemetry",
  RiskFindings: "risk_findings",
  ToolCallLogs: "tool_call_logs",
} as const;
/**
 * Class of data exported by this route.
 */
export type DataExportRouteDataSource = ClosedEnum<
  typeof DataExportRouteDataSource
>;

/**
 * The export configuration for one class of project data. A route may contain one destination of each supported type.
 */
export type DataExportRoute = {
  /**
   * Creation timestamp.
   */
  createdAt: Date;
  /**
   * Class of data exported by this route.
   */
  dataSource: DataExportRouteDataSource;
  /**
   * Whether the route is enabled.
   */
  enabled: boolean;
  /**
   * Route ID.
   */
  id: string;
  /**
   * OTEL destination configured on this route. Omitted when no OTEL destination is selected.
   */
  otelDestinationId?: string | undefined;
  /**
   * Project that owns the route.
   */
  projectId: string;
  /**
   * Last update timestamp.
   */
  updatedAt: Date;
};

/** @internal */
export const DataExportRouteDataSource$inboundSchema: z.ZodMiniEnum<
  typeof DataExportRouteDataSource
> = z.enum(DataExportRouteDataSource);

/** @internal */
export const DataExportRoute$inboundSchema: z.ZodMiniType<
  DataExportRoute,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    data_source: DataExportRouteDataSource$inboundSchema,
    enabled: z.boolean(),
    id: z.string(),
    otel_destination_id: z.optional(z.string()),
    project_id: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "data_source": "dataSource",
      "otel_destination_id": "otelDestinationId",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function dataExportRouteFromJSON(
  jsonString: string,
): SafeParseResult<DataExportRoute, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DataExportRoute$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DataExportRoute' from JSON`,
  );
}
